// DestinationNavRegion.js
import {
  defineComponent,
  computed,
  onMounted,
  onUnmounted,
  ref,
} from "/Scripts/vue.esm-browser.js";
const html = String.raw;
import { getTextWithoutSign } from "/Scripts/tools.js";
import { scrollService } from "/Services/Shop/scrollService.js";

export default defineComponent({
  name: "DestinationNavRegion",
  props: {
    quickData: {
      type: Array,
    },
    shopName: {
      type: String,
    },
    isResolved: {
      type: Boolean,
      default: false,
    },
    filteredDataByGroup: {
      type: Array,
      required: true,
    },
  },
  emits: [],
  setup(props, { emit }) {
    const filteredDataByGroup = computed(() => props.filteredDataByGroup);
    const selectedIndex = ref(-1);
    const selectedLocationIndex = ref(-1);
    const selectedThemeIndex = ref(-1);

    // 是否為單一區域，前台顯示效果不同
    const isSingleArea = computed(() => filteredDataByGroup.value.length === 1);

    // 快取常用 DOM 元素的函數
    const getElement = (selector) => document.querySelector(selector);

    // 計算區域資料的簡化版本
    const areas = computed(() => {
      const mappedAreas = filteredDataByGroup.value.map((item) => ({
        name: item.areaName,
        areas: item.subAreas.map((subArea) => ({
          name: subArea.subArea,
          areas: subArea.otherAreas.map((otherArea) => ({
            name: otherArea.otherAreaName,
          })),
        })),
      }));

      return mappedAreas.length === 1 ? mappedAreas[0].areas : mappedAreas;
    });

    const selectedArea = computed(() => areas.value[selectedIndex.value] || {});

    // 使用統一的選擇器對象進行元素查找
    const selectors = {
      area: {
        attr: () =>
          isSingleArea.value ? "data-location-name" : "data-area-name",
        getTarget: (idx) => areas.value[idx].name,
      },
      location: {
        attr: "data-location-name",
        getTarget: (idx) => selectedArea.value.areas[idx].name,
      },
      theme: {
        attr: "data-theme-name",
        getTarget: (idx, currentLocation) =>
          getTextWithoutSign(currentLocation.areas[idx].name),
      },
    };

    // 設置區域索引
    const setIndex = (idx, isClick = false) => {
      scrollService.setIndexWithScroll(selectedIndex, idx, isClick, {
        type: "area",
        params: {
          target: selectors.area.getTarget(idx),
          attr: selectors.area.attr(),
        },
      });
    };

    // 設置位置索引
    const setSelectedLocationIndex = (idx, isClick = false) => {
      scrollService.setIndexWithScroll(selectedLocationIndex, idx, isClick, {
        type: "location",
        params: {
          target: selectors.location.getTarget(idx),
        },
      });
    };

    // 優化：設置主題索引
    const setSelectedThemeIndex = (idx, isClick = false) => {
      const currentLocation = isSingleArea.value
        ? selectedArea.value
        : selectedArea.value.areas?.[selectedLocationIndex.value];

      if (!currentLocation) return;

      scrollService.setIndexWithScroll(selectedThemeIndex, idx, isClick, {
        type: "theme",
        params: {
          target: selectors.theme.getTarget(idx, currentLocation),
          currentLocation,
        },
      });
    };

    // 創建滾動處理函數
    const handleScroll = scrollService.createScrollHandler({
      areas,
      isSingleArea,
      setIndex,
      setSelectedLocationIndex,
      setSelectedThemeIndex,
      selectedArea,
      selectedLocationIndex,
    });
    const setUrl = (sarea, oarea) => {
      const currentPath = window.location.pathname; // 例如 /destination/7
      const queryString = window.location.search; // 例如 ?weekdays=1

      // 使用正規表達式抓出 /destination/Sn 中的 Sn
      const match = currentPath.match(/^\/destination\/([^\/]+)/i);

      if (match) {
        const sn = match[1];
        let newPath = "";
        if (oarea) {
          newPath = `/destination/${sn}/${sarea}/${oarea}${queryString}`;
        } else {
          newPath = `/destination/${sn}/${sarea}${queryString}`;
        }

        window.history.pushState({}, "", newPath);
      } else {
        console.error("網址不符 /destination/Sn 格式");
      }
    };
    onMounted(() => {
      // 使用 passive: true 優化滾動效能
      window.addEventListener("scroll", handleScroll, { passive: true });
    });

    onUnmounted(() => {
      // 清理事件監聽器
      window.removeEventListener("scroll", handleScroll);
    });
    const handleQuickClick = (idx, quick) => {
      setIndex(idx, true);
      setUrl(quick.subClassification, "");
    };
    return { setIndex, setUrl, handleQuickClick };
  },
  template: html`
    <div
      class="destination_nav_region"
      :class="{ 'destination_nav_region--placeholder': !isResolved }"
    >
      <div class="">
        <div class="destination_All_anchor">
          <div class="title_bar">
            <div class="title">快速前往</div>
            <div class="sub_title">{{shopName}} 各地區</div>
          </div>
          <ul class="anchor_list destination_nav_placeholder__list" v-if="!isResolved">
            <li class="anchor_btn destination_nav_placeholder__item" v-for="idx in 8" :key="idx">
              <span class="destination_nav_placeholder__pill"></span>
            </li>
          </ul>
          <ul class="anchor_list" v-if="quickData.length == 1">
            <li
              class="anchor_btn"
              v-for="(quick, idx) in quickData[0].items"
              @click="handleQuickClick(idx, quick, getSubName(quick.showField || quick.subClassificationName))"
            >
              <a href="javascript:void(0)">
                {{getSubName(quick.showField || quick.subClassificationName)}}
              </a>
            </li>
          </ul>
          <ul class="anchor_list" v-if="quickData.length > 1">
            <li
              class="anchor_btn"
              v-for="(quick, idx) in quickData"
              @click="handleQuickClick(idx, quick, quick.classificationName)"
            >
              <a href="javascript:void(0)">{{quick.classificationName}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  `,
  methods: {
    getSubName: function (showField) {
      //移除括號內的內容
      const result = showField.replace(/（.*?）/g, "");
      return result;
    },
  },
});
